var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMetroInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_metro-info",
    "data-name": "Icon metro-info",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.678,
    height: 30.678,
    viewBox: "0 0 30.678 30.678",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-info-2",
    "data-name": "Icon metro-info",
    d: "M15.992,11.035A1.442,1.442,0,0,1,17.43,9.6h.959a1.442,1.442,0,0,1,1.438,1.438v.959a1.442,1.442,0,0,1-1.438,1.438H17.43a1.442,1.442,0,0,1-1.438-1.438Zm5.752,13.9H14.075V23.019h1.917V17.267H14.075V15.35h5.752v7.669h1.917ZM17.91,1.928A15.339,15.339,0,1,0,33.248,17.267,15.339,15.339,0,0,0,17.91,1.928Zm0,27.8A12.463,12.463,0,1,1,30.372,17.267,12.463,12.463,0,0,1,17.91,29.73Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#32a8ed"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetroInfo);
export default __webpack_public_path__ + "static/media/Icon-metro-info.e5815971dba11d0b243990b7bb8b7cfe.svg";
export { ForwardRef as ReactComponent };